module.exports = __webpack_public_path__ + "img/jgsb.12bdaae2.png";